import React, { useContext, useEffect, useMemo, useState } from 'react';
import Calendar from 'react-calendar';
import 'assets/styles/common.scss';
import 'react-calendar/dist/Calendar.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import 'Pages/ProviderAdmin/providerAppointments/appointments.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import EditIcon from 'assets/images/Tab/editIcon.png';
import AddIcon from 'assets/images/Dashboard/add.png';
import ReusableButton from 'components/common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentsCallAPI } from 'store/ProviderAdmin/getAppointments/action';
import { useNavigate } from 'react-router-dom';
import {
  providerAdminAddAppointments,
  providerAdminEditAppointments,
  superAdminAppointmentsDetails,
} from 'routes/AppUrls';
import { getAppointmentsListCallAPI } from 'store/ProviderAdmin/getAppointmentList/action';
import { getAppointmentDaysProviderCallAPI } from 'store/AppointmentDaysList/action';
import SelectInput from 'components/common/Input/SelectInput';
import { Box, Menu, MenuItem, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonModal from 'components/common/Modal';
import crossIcon from 'assets/images/crossIcon.svg';
import { getAssignSpecialistListProviderCallAPI } from 'store/ProviderAdmin/assignSpecialistList/action';
import { setDate } from 'date-fns';
import ToastNotification from 'components/common/Toast';
import { assignSpecialistProviderCallAPI } from 'store/ProviderAdmin/assignSpecialist/action';
import { getUserRole } from 'utils/general';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';
import { setPageTitle } from 'store/pageTitle/action';

const localizer = momentLocalizer(moment);

const ProviderAppointments = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const userRole = getUserRole();
  const [conf, setConf] = ToastNotification();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(
    new Date()?.toLocaleDateString('en-US', { weekday: 'long' })
  );
  const [copyValue, setCopyValue] = useState('');
  const [isModalActive, setIsModalActive] = useState(false);

  const getAppointmentsData = useSelector(
    (state) => state?.getAppointmentsReducer?.data?.data
  );
  const appointmentsLoading = useSelector(
    (state) => state?.getAppointmentsReducer?.loading
  );
  const [appointmentsListData, setAppointmentsListData] = useState(
    getAppointmentsData ? getAppointmentsData : []
  );

  const getAppointmentsProviderListData = useSelector(
    (state) => state?.getAppointmentsListReducer?.data?.data
  );
  const appointmentsListLoading = useSelector(
    (state) => state?.getAppointmentsListReducer?.loading
  );
  const [appointmentsListProviderData, setAppointmentsListProviderData] =
    useState(
      getAppointmentsProviderListData ? getAppointmentsProviderListData : []
    );
  const [specialistData, setSpecialistData] = useState([]);
  const [selectSpecialistName, setSelectSpecialistName] = useState('');
  const [selectSpecialistId, setSelectSpecialistId] = useState(null);
  const [selectAppointmentId, setSelectAppointmentId] = useState(null);

  useEffect(() => {
    dispatch(setPageTitle('Appointments'));
  }, []);

  useEffect(() => {
    getAppointmentDaysList();
    getAppointmentsList();
    getAppointmentsSalonList();
  }, []);

  const getAppointmentsList = () => {
    dispatch(
      getAppointmentsCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const getAppointmentDaysList = () => {
    dispatch(
      getAppointmentDaysProviderCallAPI(
        {},
        {
          navigate: navigate,
        }
      )
    );
  };

  const getAppointmentsSalonList = () => {
    dispatch(
      getAppointmentsListCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleAppointmentProviderSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleAppointmentProviderSuccess = (res) => {
    let appointmentData = [];
    if (
      res?.data?.data?.length > 0 &&
      res?.data?.data.map((key, index) =>
        appointmentData.push({
          start: new Date(key?.slot_start_time),
          end: new Date(key?.slot_end_time),
          title:
            key?.assign_specialist !== null && userRole === 'salon-admin'
              ? `Assigned to ${key?.assign_specialist?.name}`
              : ``,
          id: key?.id,
          orderId: key?.order_id,
          isAssignButton:
            key?.assign_specialist === null && key?.order_status === null
              ? true
              : false,
          status: key?.order_status,
        })
      )
    )
      setAppointmentsListProviderData(appointmentData);
  };

  const handleSuccess = (res) => {
    setAppointmentsListData(res?.data?.data);
  };

  const parseTime = (timeStr, date) => {
    if (!timeStr || typeof timeStr !== 'string') return null;

    const [hourMin, modifier] = timeStr.split(' ');
    if (!hourMin || !modifier) return null;

    let [hours, minutes] = hourMin.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) return null;

    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    const d = new Date(date);
    d.setHours(hours, minutes, 0, 0);
    return d;
  };

  const daySlots = appointmentsListData?.filter(
    (item) => item.day_of_week?.name === selectedDay
  );

  const breakEvents = daySlots?.flatMap((item, index) => {
    const breaks =
      item.schedule_breaks?.map((brk, idx) => {
        return {
          title: brk?.break_name || `Break${idx + 1}`,
          start: parseTime(brk?.break_start_time, selectedDate),
          end: parseTime(brk?.break_end_time, selectedDate),
          type: 'break',
          id: `break-${index}-${idx}`,
        };
      }) || [];
    return breaks;
  });

  const holidayEvents = appointmentsListData
    ?.filter(
      (item) => item?.is_holiday && item?.day_of_week?.name === selectedDay
    )
    ?.map((item) => ({
      title: 'Holiday',
      start: parseTime('12:00 AM', selectedDate),
      end: parseTime('11:00 PM', selectedDate),
      type: 'holiday',
    }));

  const formatDate = (date) => moment(date).format('YYYY-MM-DD');

  const filteredEvents = useMemo(() => {
    const isHoliday = holidayEvents?.some(
      (event) => formatDate(event.start) === formatDate(selectedDate)
    );

    return isHoliday
      ? holidayEvents
      : [
          ...appointmentsListProviderData.filter(
            (event) => formatDate(event.start) === formatDate(selectedDate)
          ),
          ...breakEvents,
        ];
  }, [selectedDate, holidayEvents, appointmentsListProviderData, breakEvents]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDay(date?.toLocaleDateString('en-US', { weekday: 'long' }));
  };

  const highlightWeekends = ({ date }) => {
    const today = new Date().toDateString();
    const day = date.getDay();
    if (date.toDateString() === selectedDate?.toDateString()) return 'selected';
    if (date.toDateString() === today) return 'today';
    if (day === 0) return 'sunday';
    if (day === 6) return 'saturday';
    return null;
  };

  const handleNavigationClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const formatShortWeekday = (locale, date) => {
    const weekdays = {
      en: ['S', 'M', 'T', 'W', 'T', 'F', 'S'], // English initials
      ar: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'], // Arabic initials
    };

    return locale === 'ar'
      ? weekdays.ar[date.getDay()]
      : weekdays.en[date.getDay()];
  };

  const handleEventClick = (event) => {
    if (event?.type !== 'break' && event?.type !== 'holiday') {
      navigate(superAdminAppointmentsDetails(locale), {
        state: { customerId: event?.id },
      });
    }
  };

  const eventStyleGetter = (event) => {
    if (event.type === 'holiday') {
      return {
        style: {
          backgroundColor: '#FFFFFF',
          fontWeight: 'bold',
          border: 'none !important',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          justifyContent: 'center',
        },
        className: 'holiday-event',
      };
    } else {
      return {
        style: {
          backgroundColor: getStatusLegendColor(event?.status),
          fontWeight: 'bold',
          border: 'none !important',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
          justifyContent: 'center',
        },
      };
    }
  };

  const CustomEvent = ({ event }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    if (event.type === 'holiday') {
      return <div className="holiday-event">{event.title}</div>;
    }

    const handleOpenMenu = (e) => {
      e.stopPropagation(); // Prevent triggering calendar's event click
      setAnchorEl(e.currentTarget);
    };

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    const handleAssign = (e) => {
      e.stopPropagation();
      setSelectSpecialistName('');
      setSelectSpecialistId(null);
      setSelectAppointmentId(null);
      getSpecialistList(event?.orderId);
      setSelectAppointmentId(event?.orderId);
      setIsModalActive(true);
      handleCloseMenu();
    };

    const getSpecialistList = (orderId) => {
      dispatch(
        getAssignSpecialistListProviderCallAPI(
          {},
          {
            orderId: orderId,
            run: true,
            handleFunction: (res) => handleSpecialistListSuccess(res),
            navigate: navigate,
          }
        )
      );
    };

    const handleSpecialistListSuccess = (res) => {
      let filterData = res?.data?.data.specialist_list.filter(
        (val) => val?.is_available === true
      );
      setSpecialistData(filterData);
      getAppointmentsList();
      getAppointmentsSalonList();
    };

    const handleDetails = () => {
      navigate(superAdminAppointmentsDetails(locale), {
        state: { customerId: event?.id },
      });
      handleCloseMenu();
    };

    return (
      <div className="flex justify-between md:w-[75%] lg:w-[80%] xl:w-[85%] 2xl:w-[88%] ">
        <span className="truncate">{event.title}</span>
        {event?.type !== 'break' && event?.type !== 'holiday' && (
          <>
            {/* <MoreVertIcon fontSize="small" onClick={handleOpenMenu} />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            > */}

            {/* {userRole === 'salon-admin' && event?.isAssignButton && (
              <ReusableButton
                fullWidth={false}
                variant="contained"
                color="#FFFFFF"
                fontSize="12px"
                fontWeight="400"
                padding="5px"
                height="16px"
                bgColor="#1A1A1A"
                brColor="#1A1A1A"
                fontFamily="Akkurat"
                onClick={handleAssign}
              >
                <FormattedMessage id="Assign" />
              </ReusableButton>
            )} */}

            {/* <MenuItem onClick={handleAssign}>Assign</MenuItem> */}
            {/* <MenuItem onClick={handleDetails}>Details</MenuItem> */}
            {/* </Menu> */}
          </>
        )}
      </div>
    );
  };

  const handleSpecialistChange = (e) => {
    setSelectSpecialistName(e?.target?.value?.specialist_name_en);
    setSelectSpecialistId(e?.target?.value?.specialist_id);
  };

  const isHoliday = holidayEvents?.some(
    (event) => formatDate(event.start) === formatDate(selectedDate)
  );

  const handleInputChange = (e) => {
    setCopyValue(e?.target?.value);
  };

  const handleAssignSpecialist = () => {
    if (selectSpecialistName === '') {
      return setConf({
        msg: 'No specialist is available',
        variant: 'error',
      });
    }

    let body = {
      appointment_id: selectAppointmentId,
      specialist_id: [selectSpecialistId],
    };

    dispatch(
      assignSpecialistProviderCallAPI(body, {
        run: true,
        handleFunction: (res) => handleSpecialistAssignSuccess(res),
        navigate: navigate,
      })
    );
  };

  const handleSpecialistAssignSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setIsModalActive(false);
  };

  const statusLegend = [
    {
      name: 'missed',
      text: <FormattedMessage id="Missed" />,
    },
    {
      name: 'completed',
      text: <FormattedMessage id="Completed" />,
    },
    {
      name: 'upcoming',
      text: <FormattedMessage id="Upcoming" />,
    },
    {
      name: 'cancelled',
      text: <FormattedMessage id="Cancelled" />,
    },
  ];

  const getStatusLegendColor = (status) => {
    switch (status) {
      case 'missed':
        return '#FFA500';
      case 'completed':
        return '#28A745';
      case 'upcoming':
        return '#007BFF';
      case 'cancelled':
        return '#DC3545';
      case null:
        return '#007BFF';
    }
  };

  const isLoading = appointmentsLoading || appointmentsListLoading;

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        {isLoading ? (
          <div className="flex gap-4 p-[10px] bg-white">
            <div className="calendar-container">
              <div className="mb-2">
                <ShimmerBox width="150px" height="32px" />
              </div>
              <div
                style={{
                  width: '350px',
                  height: '350px',
                  background: '#f0f0f0',
                  borderRadius: '4px',
                }}
              >
                <ShimmerBox width="100%" height="100%" />
              </div>
            </div>
            <div className="w-100">
              <div className="mb-3">
                <ShimmerBox width="100%" height="24px" />
                <ShimmerBox width="100%" height="24px" />
                {/* <Row className="m-0 p-0 bg-[#ffffff] p-2 w-[75%]">
                  <ShimmerBox width="180px" height="14px" />
                  <div className="flex items-center flex-wrap gap-4 m-0 p-0 pb-3 mt-2">
                    {[1, 2, 3, 4].map((item) => (
                      <div key={item} className="flex items-center gap-2">
                        <ShimmerCircle size="12px" />
                        <ShimmerBox
                          width="80px"
                          height="14px"
                          className="mb-0"
                        />
                      </div>
                    ))}
                  </div>
                </Row> */}
                {/* <ShimmerBox width="120px" height="16px" /> */}
              </div>
              <div
                className="big-calendar-container"
                style={{
                  height: '100vh',
                  background: '#f0f0f0',
                  borderRadius: '4px',
                }}
              >
                <ShimmerBox width="100%" height="100%" />
              </div>
            </div>
          </div>
        ) : appointmentsListData.length > 0 &&
          appointmentsListData?.some(
            (item) => item.day_of_week?.name === selectedDay
          ) ? (
          <div className="flex gap-4 p-0">
            <>
              <div className="calendar-container">
                <div className="mb-2">
                  <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600  m-0">
                    <FormattedMessage id="Schedule" />
                  </h2>
                </div>

                <Calendar
                  next2Label={null}
                  prev2Label={null}
                  tileClassName={highlightWeekends}
                  formatShortWeekday={formatShortWeekday}
                  onChange={handleDateChange}
                  value={selectedDate}
                  locale={locale === 'en' ? 'en' : 'ar'}
                  navigationLabel={({ date, label }) => (
                    <button
                      onClick={handleNavigationClick}
                      style={{
                        minWidth: '44px',
                        background: 'none',
                        cursor: 'not-allowed',
                      }}
                      disabled
                    >
                      {label}
                    </button>
                  )}
                />
              </div>

              <div className="w-100">
                <div className="flex items-center justify-between w-100 mb-3">
                  <h2 className="p-0 m-0 fs-24 fw-400 fc-292D32 ff-Akkurat items-center">
                    {selectedDate &&
                      (locale === 'ar'
                        ? new Intl.DateTimeFormat('ar-EG', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          }).format(new Date(selectedDate))
                        : new Intl.DateTimeFormat('en-US', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          }).format(new Date(selectedDate)))}
                  </h2>

                  <Row className="m-0 p-0 mr-4 bg-[#ffffff] p-2 w-[75%]">
                    <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                      <FormattedMessage id="Appointment status legend" />
                    </p>

                    <div className="flex items-center flex-wrap gap-4 m-0 p-0 pb-3 mt-2">
                      {statusLegend.map((item) => (
                        <div
                          key={item?.name}
                          className="flex items-center gap-2"
                        >
                          <div
                            className={`w-3 h-3 rounded-full`}
                            style={{
                              backgroundColor: getStatusLegendColor(item?.name),
                            }}
                          ></div>
                          <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                            {item?.text}
                          </p>
                        </div>
                      ))}
                    </div>
                  </Row>

                  {userRole !== 'specialist-admin' && (
                    <div className="ml-4">
                      <ReusableButton
                        fullWidth={false}
                        variant="contained"
                        color="#FFFFFF"
                        fontSize="14px"
                        fontWeight="400"
                        padding="8px 16px"
                        bgColor="#C56616"
                        brColor="#C56616"
                        fontFamily="Akkurat"
                        onClick={() => {
                          navigate(providerAdminAddAppointments(locale));
                        }}
                      >
                        <FormattedMessage
                          className="whitespace-nowrap"
                          id="Book Appointment"
                        />
                      </ReusableButton>
                    </div>
                  )}

                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center cursor-pointer flex-nowrap ml-4"
                    onClick={() =>
                      navigate(providerAdminEditAppointments(locale), {
                        state: { selectedDay },
                      })
                    }
                  >
                    <img
                      src={EditIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                    />
                    <p className="p-0 m-0 fs-16 fc-C56616 family_outfit_medium_500 whitespace-nowrap">
                      <FormattedMessage id="Edit Timing" />
                    </p>
                  </Stack>
                </div>

                <div className="big-calendar-container">
                  <BigCalendar
                    key={`${selectedDate}-${filteredEvents.length}`}
                    localizer={localizer}
                    events={filteredEvents}
                    startAccessor="start"
                    endAccessor="end"
                    views={['day']}
                    defaultView="day"
                    date={selectedDate}
                    toolbar={false}
                    dayLayoutAlgorithm="no-overlap"
                    onSelectEvent={handleEventClick}
                    min={
                      isHoliday
                        ? null
                        : parseTime(
                            appointmentsListData?.find(
                              (item) => item.day_of_week?.name === selectedDay
                            )?.start_time,
                            selectedDate
                          )
                    }
                    max={
                      isHoliday
                        ? null
                        : parseTime(
                            appointmentsListData?.find(
                              (item) => item.day_of_week?.name === selectedDay
                            )?.end_time,
                            selectedDate
                          )
                    }
                    style={{ height: '100vh' }}
                    eventPropGetter={eventStyleGetter}
                    components={{ event: CustomEvent }}
                  />
                </div>
              </div>
            </>
          </div>
        ) : (
          <div className="flex gap-4 p-0">
            <>
              <div className="calendar-container">
                <div className="mb-2">
                  <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600  m-0">
                    <FormattedMessage id="Schedule" />
                  </h2>
                </div>

                <Calendar
                  next2Label={null}
                  prev2Label={null}
                  tileClassName={highlightWeekends}
                  formatShortWeekday={formatShortWeekday}
                  onChange={handleDateChange}
                  value={selectedDate}
                  locale={locale === 'en' ? 'en' : 'ar'}
                  navigationLabel={({ date, label }) => (
                    <button
                      onClick={handleNavigationClick}
                      style={{
                        minWidth: '44px',
                        background: 'none',
                        cursor: 'not-allowed',
                      }}
                      disabled
                    >
                      {label}
                    </button>
                  )}
                />
              </div>

              <div className="w-100">
                <div className="flex justify-between">
                  <h2 className="p-0 m-0 fs-24 fw-400 fc-292D32 ff-Akkurat">
                    {selectedDate &&
                      (locale === 'ar'
                        ? new Intl.DateTimeFormat('ar-EG', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          }).format(new Date(selectedDate))
                        : new Intl.DateTimeFormat('en-US', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          }).format(new Date(selectedDate)))}
                  </h2>
                </div>

                <div
                  className="mt-3 flex justify-center items-center align-center"
                  style={{ height: '600px', background: 'white' }}
                >
                  <div className="flex gap-4 justify-center">
                    <ReusableButton
                      fullWidth={false}
                      variant="contained"
                      color="#FFFFFF"
                      fontSize="16px"
                      fontWeight="400"
                      padding="12px 50px"
                      height="50px"
                      bgColor="#1A1A1A"
                      brColor="#1A1A1A"
                      fontFamily="Akkurat"
                      onClick={() =>
                        navigate(providerAdminEditAppointments(locale), {
                          state: { selectedDay },
                        })
                      }
                    >
                      <img
                        src={AddIcon}
                        alt="icon"
                        style={{ height: '24px', width: '24px' }}
                        className="me-2"
                      />
                      <FormattedMessage id="Create New" />
                    </ReusableButton>

                    {getAppointmentsData?.length > 0 && (
                      <div
                        className="flex gap-4 justify-center"
                        style={{ width: '350px' }}
                      >
                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#FFFFFF"
                          fontSize="16px"
                          fontWeight="400"
                          padding="12px 50px"
                          height="50px"
                          bgColor="#1A1A1A"
                          brColor="#1A1A1A"
                          fontFamily="Akkurat"
                          onClick={() =>
                            copyValue !== '' &&
                            navigate(providerAdminEditAppointments(locale), {
                              state: { selectedDay, copyValue },
                            })
                          }
                        >
                          <FormattedMessage id="Copy" />
                        </ReusableButton>

                        <SelectInput
                          marginLabelTop={'0'}
                          marginTop={'0'}
                          placeholder={intl.formatMessage({
                            id: 'Select a day',
                          })}
                          value={copyValue && copyValue?.label}
                          data={
                            getAppointmentsData
                              ? getAppointmentsData?.map((key) => ({
                                  label: key?.day_of_week?.name?.slice(0, 3),
                                  slug: key?.day_of_week?.slug,
                                })) || []
                              : []
                          }
                          onChange={(e) => handleInputChange(e)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          </div>
        )}
      </Col>

      {/* Edit  Modal  */}
      <CommonModal
        padding={'32px 48px'}
        width={'600px'}
        modalActive={isModalActive}
        handleClose={() => setIsModalActive(false)}
        innerContent={
          <Box>
            <Row>
              <Col xs={12} md={12}>
                <div className="flex justify-between items-center">
                  <h2 className="p-0 m-0 fs-24 fc-292D32 fw-400 ff-Akkurat_Bold">
                    {<FormattedMessage id="Assign Specialist" />}
                  </h2>
                  <img
                    src={crossIcon}
                    alt={'icon'}
                    style={{
                      cursor: 'pointer',
                      height: '32px',
                      width: '32px',
                    }}
                    onClick={() => setIsModalActive(false)}
                  />
                </div>
              </Col>

              <Col xs={12} md={12} className="mt-3">
                <SelectInput
                  label={<FormattedMessage id="Specialist" />}
                  placeholder={intl.formatMessage({ id: 'Specialist' })}
                  name={'specialist'}
                  value={selectSpecialistName}
                  data={specialistData}
                  onChange={(e) => handleSpecialistChange(e)}
                />
              </Col>
            </Row>

            <Row className="mt-4 items-center">
              <div className="flex justify-center">
                <Stack direction="horizontal" gap={3} className="items-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#292D32"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="transparent"
                    fontFamily="Akkurat"
                    onClick={() => setIsModalActive(false)}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 35px"
                    height="44px"
                    bgColor="#292D32"
                    fontFamily="Akkurat"
                    onClick={() => handleAssignSpecialist()}
                  >
                    <FormattedMessage id="Save" />
                  </ReusableButton>
                </Stack>
              </div>
            </Row>
          </Box>
        }
      />
      {/* Edit Modal  */}
    </Row>
  );
};

export default ProviderAppointments;
